/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Login_Already_AssociatedInputs */

const nl_auth_password_errors_login_already_associated = /** @type {(inputs: Auth_Password_Errors_Login_Already_AssociatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze login is al gekoppeld aan een account`)
};

/**

* @param {Auth_Password_Errors_Login_Already_AssociatedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_login_already_associated = /** @type {((inputs?: Auth_Password_Errors_Login_Already_AssociatedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Login_Already_AssociatedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_login_already_associated(inputs)
});
export { auth_password_errors_login_already_associated as "auth.password_errors.login_already_associated" }